import { useRef } from 'react';
import { useStoreId } from '@thd-nucleus/experience-context';
import { useProductDeprecated } from '@thd-nucleus/data-sources/react/dataModel/migration';

const isFulfillable = (product) => {
  return !!(product?.fulfillment?.fulfillmentOptions || []).find((option) => option.fulfillable);
};

const isDiscontinued = (product) => {
  return !!(product?.availabilityType?.discontinued);
};

const getNearByStore = (fulfillment) => {
  const locations = fulfillment?.locations || [];
  if (locations.length > 1) {
    const nearbyStore = locations.find((location) => !location.isAnchor);
    return nearbyStore;
  }
  return null;
};

const getLocalStore = (fulfillment) => {
  const locations = fulfillment?.locations || [];
  const localStore = locations.find((location) => location.isAnchor);
  return localStore;
};

const isBOPISHaveQuantity = (fulfillment) => {
  const pickupService = (fulfillment?.fulfillmentOptions || []).find((option) => option.type === 'pickup');
  const bopisFulfillment = (pickupService?.services || []).find((service) => service.type === 'bopis');
  if (!bopisFulfillment) {
    return false;
  }
  const nearByStoreLocation = getNearByStore(bopisFulfillment);
  const localStoreLocation = getLocalStore(bopisFulfillment);
  return pickupService?.fulfillable
    && (localStoreLocation?.inventory?.quantity > 0 || nearByStoreLocation?.inventory?.quantity > 0);
};

const isDisplayableBasedOnFulfillment = (product) => {
  if (!isDiscontinued(product?.availabilityType)
    && (product?.fulfillment?.isBODFS
      || product?.fulfillment?.isSTH
      || product?.fulfillment?.isBOSS
      || isBOPISHaveQuantity(product?.fulfillment))
  ) {
    return true;
  }
  return false;
};

export const ProductLoader = ({ itemId, storeId: propStoreId, children }) => {
  const storeId = propStoreId || useStoreId();
  const loadedStoreId = useRef(storeId);
  const isFulfillableRef = useRef(true);
  const isDisplayableRef = useRef(true);
  const domains = ['identifiers', 'info', 'media', 'pricing', 'reviews'];
  const clientDomains = ['availabilityType', 'fulfillment'];
  const resp = useProductDeprecated({ itemId, storeId, domains });
  const skip = storeId === '8119';
  const clientResp = useProductDeprecated({
    itemId,
    storeId,
    ssr: false,
    domains: clientDomains,
    skip
  }, 'clientOnlyProduct');

  if (resp.data && !resp.loading) {
    loadedStoreId.current = resp.variables?.storeId || storeId;
  }

  if (clientResp.data?.product?.fulfillment) {
    const isProductFulfillable = isFulfillable(clientResp.data.product);
    isFulfillableRef.current = isProductFulfillable;
  } else if (clientResp.data?.product) {
    isFulfillableRef.current = false;
  }

  if (clientResp.data?.product?.availabilityType && clientResp.data?.product?.fulfillment) {
    const isFbtDisplayable = isDisplayableBasedOnFulfillment(clientResp.data.product);
    isDisplayableRef.current = isFbtDisplayable;
  }
  return children(resp, loadedStoreId.current, isFulfillableRef.current, isDisplayableRef.current);
};

export default ProductLoader;
